import moment from 'moment';
import { useState } from 'react';
import * as XLSX from 'xlsx';
import qs from 'qs';

// Returns [activeBtn, todayDate, weekStartDate, weekEndsDate]
export const UseFilter = (search) => {
  const todayDate = moment().startOf('day');
  const weekStartDate = moment().startOf('week').add(1, 'days'); // Monday
  const weekEndsDate = moment().endOf('week').add(1, 'days');
  let activeBtn = 'Lifetime';
  if (search) {
    const queryParams = qs.parse(search.replace('?', ''));
    const dateType = queryParams.date_type;
    if (dateType) {
      activeBtn = dateType;
    } else if (queryParams.conditional && queryParams.conditional.createdAt) {
      // fallback: if conditional exists, but no date_type, treat as custom
      activeBtn = 'Custom';
    }
  }
  return [activeBtn, todayDate, weekStartDate, weekEndsDate];
};

export const UseDataForExcel = () => {
  const [exportData, setExportData] = useState([]);
  const convertToReadable = (rawData, inputFields) => {
    if (inputFields) {
      let freshData = [];
      const newFreshData = rawData.map((data, index) => {
        let newItem = {};
        newItem['SR No'] = index + 1;
        Object.keys(inputFields) &&
          Object.keys(inputFields).map((item, index) => {
            if (inputFields[item] && inputFields[item].type === 'string') {
              newItem[inputFields[item].title] =
                inputFields[item].inputType == 'date'
                  ? data[item] && moment(data[item]).format('DD-MMM-YYYY')
                  : inputFields[item].inputType == 'datetime-local'
                  ? moment(data[item]).format('DD-MMM-YYYY hh:mm:ss A')
                  : data[item]
                  ? data[item]
                  : '';
            }
            if (inputFields[item] && inputFields[item].type === 'text') {
              newItem[item] = data[item] ? data[item] : '';
            }
            if (inputFields[item] && inputFields[item].type === 'select') {
              newItem[item] = data[item] ? data[item] : '';
            }
            if (inputFields[item] && inputFields[item].type === 'related') {
              newItem[item] = data[item]
                ? !inputFields[item].static
                  ? data[item][inputFields[item].field]
                  : data[item]
                : '';
            }
            if (inputFields[item] && inputFields[item].type === 'checkbox') {
              newItem[item] = data[item] ? 'YES' : 'NO';
            }
          });

        newItem['Created By'] =
          data.created_by && data.created_by.name ? data.created_by.name : '';

        newItem['Updated By'] =
          data.updated_by && data.updated_by.name ? data.updated_by.name : '';

        newItem['Created At'] = data.createdAt
          ? moment(data.createdAt).format('DD-MM-YYYY hh:mm:ss A')
          : '';

        newItem['Updated At'] = data.updatedAt
          ? moment(data.updatedAt).format('DD-MM-YYYY hh:mm:ss A')
          : '';

        return newItem;
      });
      //   console.log(newFreshData);
      setExportData(newFreshData);
    }
  };
  return [convertToReadable, exportData];
};
